import { useState } from "react";
import axios from "axios";


function App() {
    const [loading, setLoading] = useState(false);
    const [showDelayText, setShowDelayText] = useState(false);

    const [step, setStep] = useState(1);
    const [mode, setMode] = useState("");


    const [input, setInput] = useState("");
    const [reply, setReply] = useState("");
    const [plate, setPlate] = useState("");
    const [km, setKm] = useState("");

    const [symptoms, setSymptoms] = useState([]);
    const [warningLight, setWarningLight] = useState("");
    const [locations, setLocations] = useState([]);
    const [frequency, setFrequency] = useState([]);
    const [severeness, setSevereness] = useState([]);
    const [extras, setExtras] = useState([]);

    const [symptomInput, setSymptomInput] = useState("");
    const [locationInput, setLocationInput] = useState("");
    const [frequencyInput, setFrequencyInput] = useState("");
    const [severenessInput, setSeverenessInput] = useState("");
    const [extraInput, setExtraInput] = useState("");

    const formatPlate = (value) =>
        value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 6);

    const toggleOption = (value, state, setState) => {
        setState((prev) => {
            const updated = prev.includes(value)
                ? prev.filter((v) => v !== value)
                : [...prev, value];

            console.log(updated); // ✅ correct

            return updated;
        });
    };
    const goBack = () => {
        if (step === 9) setStep(2);
        else if (step === 2) setStep(1);
    };
    const symptoomOpties = [
        "Kloppend geluid",
        "Tikkend geluid",
        "Piepend geluid",
        "Schurend / slijpend geluid",
        "Trilling",
        "Vermogensverlies",
        "Moeilijk starten",
        "Waarschuwingslampje",
        "Oververhitting",
        "Rook / geur"
    ]
    const locatieOpties = [
        "Voorzijde",
        "Achterzijde",
        "Linkerkant",
        "Rechterkant",
        'Midden van de auto',
        "Motorruimte",
        "Onder de auto",
        "In de auto",
        "Niet zeker"
    ]
    const frequentieOpties = [
        "Bij drempels / hobbelige weg",
        "Tijdens accelereren",
        "Tijdens remmen",
        "Tijdens sturen",
        "Op hoge snelheid",
        "Op lage snelheid",
        "Alleen bij koude motor",
        "Constant aanwezig",
        "Alleen stationair"
    ]
    const hevigheidOpties = [
        "Wordt langzaam erger",
        "Ontstond plotseling",
        "Soms aanwezig",
        "Altijd aanwezig"
    ]
    const extraOpties = [
        "Recent onderhoud gehad",
        "Recent onderdelen vervangen",
        "Schade / botsing gehad"
    ]

    const sendMessage = async () => {
        setLoading(true);
        setStep(9);
        setShowDelayText(false);
        if (reply !== "") {
            setReply("")
        }

        // na 5 sec extra tekst tonen
        setTimeout(() => {
            setShowDelayText(true);
        }, 5000);
        let prompt = {}
        if (mode === "form") {
            prompt = {
                ...(plate && {plate: plate }),
                ...(km && {km: km }),
                ...(symptoms.length > 0 && {symptoms: symptoms }),
                ...(symptomInput && {symptomInput: symptomInput }),
                ...(warningLight && {warningLight: warningLight }),
                ...(locations.length > 0 && {locations: locations }),
                ...(locationInput && {locationInput: locationInput }),
                ...(frequency.length > 0 && {frequency: frequency }),
                ...(frequencyInput && {frequencyInput: frequencyInput }),
                ...(severeness.length > 0 && {severeness: severeness }),
                ...(severenessInput && {severenessInput: severenessInput }),
                ...(extras.length > 0 && {extras: extras }),
                ...(extraInput && {extraInput: extraInput })
            }
        } else {
            prompt = {
                ...(plate && {plate: plate }),
                ...(km && {km: km }),
                ...(input && {message: input })
            }
        }


        console.log(prompt)
        try {
            const res = await axios.post("https://beunbaasdiagnoseserver.onrender.com/api/chat", prompt);

            setReply(res.data.reply);
        } catch (err) {
            console.error("API error:", err); }
        setLoading(false);
    };
    if (step === 1 ) {
        return (
            <div className="min-h-screen bg-slate-900 text-white pb-10 pt-5">
                <div className="text-center mb-5">
                    <h1 className="text-4xl font-bold mb-1 text-slate-100">
                        Beun Baas Diagnose
                    </h1>
                    <h3 className="text-xl font-bold mb-2 italic text-slate-200">
                        Drive it. Break it. Diagnose it.
                    </h3>
                    <p className="text-slate-400">Slimme voertuigdiagnose en garagehulp voor de auto eigenaren en de doe-het-zelver.</p>
                </div>
                <div className="max-w-2xl mx-auto bg-slate-800 rounded-2xl shadow-xl p-8">
                    <h2 className="text-3xl font-bold mb-8">
                        Voertuig gegevens
                    </h2>

                    <label className="text-sm text-slate-400 mb-1 block">
                        Kenteken:
                    </label>
                    <div
                        className="flex items-center bg-yellow-400 rounded-lg overflow-hidden border-2 border-black w-full mb-3 max-w-xs">

                        {/* EU / NL blauwe strip */}
                        <div className="bg-blue-600 text-white px-2 py-3 text-xs font-bold flex flex-col items-center">
                            <span>NL</span>
                            <span className="text-[10px]">🇪🇺</span>
                        </div>

                        {/* input */}
                        <input
                            value={plate}
                            onChange={(e) => setPlate(formatPlate(e.target.value))}
                            placeholder="12AB34"
                            className={`bg-yellow-400 text-black font-mono text-xl tracking-[0.3em] uppercase text-center w-full outline-none
  ${plate.length > 6 ? "text-red-600" : ""}`}
                        />
                    </div>
                    <div className="w-full">
                        <label className="text-sm text-slate-400 mb-1 block">
                            Kilometerstand:
                        </label>

                        <div className="relative">
                            <input
                                value={km}
                                onChange={(e) => setKm(e.target.value)}
                                placeholder="bijv. 210000"
                                className="w-full p-4 pr-16 rounded-xl bg-slate-700 border border-slate-600
                 text-white placeholder-slate-400
                 focus:outline-none focus:ring-2 focus:ring-blue-500
                 transition"
                            />

                            <span className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 text-sm">
      km
    </span>
                        </div>

                        <p className="text-xs text-slate-500 mt-1 mb-3">
                            Vul de actuele kilometerstand in van de auto
                        </p>
                    </div>

                    <h2 className="text-xl font-bold mb-6">
                        Hoe wil je het probleem beschrijven?
                    </h2>

                    <button
                        className="w-full bg-blue-600 p-3 rounded mb-3"
                        onClick={() => {
                            setMode("form");
                            setStep(2);
                        }}
                    >
                        Vragenlijst
                    </button>

                    <button
                        className="w-full bg-blue-800 p-3 rounded"
                        onClick={() => {
                            setMode("free");
                            setStep(2);
                        }}
                    >
                        Zelf omschrijven
                    </button>

                </div>
            </div>
        )
    }
    if (step === 2 && mode === "form") {
        return (
            <div className="min-h-screen bg-slate-900 text-white pb-10 pt-5">
                <div className="text-center mb-5">
                    <h1 className="text-4xl font-bold mb-1 text-slate-100">
                        Beun Baas Diagnose
                    </h1>
                    <h3 className="text-xl font-bold mb-2 italic text-slate-200">
                        Drive it. Break it. Diagnose it.
                    </h3>
                    <p className="text-slate-400">Slimme voertuigdiagnose en garagehulp voor de auto eigenaren en de
                        doe-het-zelver.</p>
                </div>
                <div className="max-w-2xl mx-auto bg-slate-800 rounded-2xl shadow-xl p-8">
                    <button
                        className="mb-4 hover:bg-slate-500 p-1 px-2 rounded"
                        onClick={goBack}
                    >
                        ← Terug
                    </button>
                    <h2 className="text-4xl font-bold mb-8">
                        Probleem omschrijving
                    </h2>

                    <div className="bg-slate-700 p-5 rounded-xl mt-6">
                        <h3 className="text-xl font-semibold mb-3">Wat merk je? *</h3>
                        <div className='mb-3'>
                            {symptoomOpties.map((option) => (
                                <label
                                    key={option}
                                    className="flex items-center gap-2 py-1">
                                    <input
                                        type="checkbox"
                                        checked={symptoms.includes(option)}
                                        onChange={() => toggleOption(option, symptoms, setSymptoms)}
                                    />
                                    {option}

                                    {option === "Waarschuwingslampje" &&
                                        symptoms.includes("Waarschuwingslampje") && (
                                            <input
                                                type="text"
                                                placeholder="Welk lampje?"
                                                value={warningLight}
                                                onChange={(e) =>
                                                    setWarningLight(e.target.value)
                                                }
                                            />
                                        )}
                                    <br/>
                                </label>
                            ))}
                        </div>
                        <p>Eigen omschrijving</p>
                        <input
                            className="w-full p-3 rounded-lg bg-slate-700 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={symptomInput}
                            onChange={(e) => setSymptomInput(e.target.value)}
                            placeholder="Omschrijf de symptomen"
                        />
                    </div>
                    <div className="bg-slate-700 p-5 rounded-xl mt-6">
                        <h3 className="text-xl font-semibold">Waar merk je het?</h3>
                        <p className="mb-3">(optioneel)</p>
                        <div className="mb-3">
                            {locatieOpties.map((option) => (
                                <label key={option} className="flex items-center gap-2 py-1">
                                    <input
                                        type="checkbox"
                                        checked={locations.includes(option)}
                                        onChange={() => toggleOption(option, locations, setLocations)}
                                    />
                                    {option}
                                </label>
                            ))}
                        </div>
                        <p>Eigen omschrijving</p>
                        <input
                            className="w-full p-3 rounded-lg bg-slate-700 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={locationInput}
                            onChange={(e) => setLocationInput(e.target.value)}
                            placeholder="Beschrijf waar je het probleem ervaart"
                        />
                    </div>
                    <div className="bg-slate-700 p-5 rounded-xl mt-6">
                        <h3 className="text-xl font-semibold">Wanneer merk je het?</h3>
                        <p className="mb-3">(optioneel)</p>
                        {frequentieOpties.map((option) => (
                            <label key={option} className="flex items-center gap-2 py-1">
                                <input
                                    type="checkbox"
                                    checked={frequency.includes(option)}
                                    onChange={() => toggleOption(option, frequency, setFrequency)}
                                />
                                {option}
                                <br/>
                            </label>
                        ))}
                        <p>Eigen omschrijving</p>
                        <input
                            className="w-full p-3 rounded-lg bg-slate-700 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={frequencyInput}
                            onChange={(e) => setFrequencyInput(e.target.value)}
                            placeholder="Beschrijf wanneer je het probleem ervaart"
                        />
                    </div>
                    <div className="bg-slate-700 p-5 rounded-xl mt-6">
                        <h3 className="text-xl font-semibold">Hoe hevig is het?</h3>
                        <p className="mb-3">(optioneel)</p>
                        {hevigheidOpties.map((option) => (
                            <label key={option} className="flex items-center gap-2 py-1">
                                <input
                                    type="checkbox"
                                    checked={severeness.includes(option)}
                                    onChange={() => toggleOption(option, severeness, setSevereness)}
                                />
                                {option}
                                <br/>
                            </label>
                        ))}
                        <p>Eigen omschrijving</p>
                        <input
                            className="w-full p-3 rounded-lg bg-slate-700 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={severenessInput}
                            onChange={(e) => setSeverenessInput(e.target.value)}
                            placeholder="Beschrijf hoe hevig het is"
                        />
                    </div>
                    <div className="bg-slate-700 p-5 rounded-xl mt-6">
                        <h3 className="text-xl font-semibold">Meer informatie</h3>
                        <p className="mb-3">(optioneel)</p>
                        {extraOpties.map((option) => (
                            <label key={option} className="flex items-center gap-2 py-1">
                                <input
                                    type="checkbox"
                                    checked={extras.includes(option)}
                                    onChange={() => toggleOption(option, extras, setExtras)}
                                />
                                {option}
                                <br/>
                            </label>
                        ))}
                        <p>Eigen omschrijving</p>
                        <input
                            className="w-full p-3 rounded-lg bg-slate-700 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={extraInput}
                            onChange={(e) => setExtraInput(e.target.value)}
                            placeholder="Beschrijf overige belangrijke informatie"
                        />
                    </div>

                    <button
                        className="w-full bg-blue-600 p-3 rounded mb-3"
                        onClick={sendMessage}>
                        Start diagnose
                    </button>
                </div>
            </div>)
            ;
    }
    if (step === 2 && mode === "free") {
        return (
            <div className="min-h-screen bg-slate-900 text-white pb-10 pt-5">
                <div className="text-center mb-5">
                    <h1 className="text-4xl font-bold mb-1 text-slate-100">
                        Beun Baas Diagnose
                    </h1>
                    <h3 className="text-xl font-bold mb-2 italic text-slate-200">
                        Drive it. Break it. Diagnose it.
                    </h3>
                    <p className="text-slate-400">Slimme voertuigdiagnose en garagehulp voor de auto eigenaren en de
                        doe-het-zelver.</p>
                </div>
                <div className="max-w-2xl mx-auto bg-slate-800 rounded-2xl shadow-xl p-8">
                    <button
                        className="mb-4 hover:bg-slate-500 p-1 px-2 rounded"
                        onClick={goBack}
                    >
                        ← Terug
                    </button>
                    <h2 className="text-4xl font-bold mb-8">
                        Probleem omschrijving - zelf invullen
                    </h2>
                    <p className="mb-2 text-sm text-slate-400">
                        Let op: omschrijf het probleem zo gedetailleerd mogenlijk. Denk aan geluiden, wanneer het
                        gebeurt (bijv. bij starten, remmen, snelheid),
                        en of er waarschuwingslampjes branden etc.
                    </p>
                    <textarea
                        className="w-full p-4 rounded-xl bg-slate-700 border border-slate-600
             text-white placeholder-slate-400
             focus:outline-none focus:ring-2 focus:ring-blue-500
             transition resize-none"
                        rows={5}
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Beschrijf het probleem..."
                    />
                    <br/>
                    <button
                        className="w-full bg-blue-600 p-3 rounded mb-3"
                        onClick={sendMessage}>
                        Diagnose starten
                    </button>
                </div>
            </div>)

    }
    if (step === 9) {
        return (
            <div className="min-h-screen bg-slate-900 text-white pb-10 pt-5">
                <div className="text-center mb-5">
                    <h1 className="text-4xl font-bold mb-1 text-slate-100">
                        Beun Baas Diagnose
                    </h1>
                    <h3 className="text-xl font-bold mb-2 italic text-slate-200">
                        Drive it. Break it. Diagnose it.
                    </h3>
                    <p className="text-slate-400">Slimme voertuigdiagnose en garagehulp voor de auto eigenaren en de
                        doe-het-zelver.</p>
                </div>
                <div className="max-w-2xl mx-auto bg-slate-800 rounded-2xl shadow-xl p-8">
                    <button
                        className="mb-4 hover:bg-slate-500 p-1 px-2 rounded"
                        onClick={goBack}
                    >
                        ← Terug
                    </button>
                    <h2 className="text-4xl font-bold mb-8">
                        Diagnose
                    </h2>
                    {loading && (
                        <div className="mt-4 bg-slate-800 p-4 rounded-lg">
                            <p>Aan het nadenken...</p>

                            {showDelayText && (
                                <p className="text-slate-400 mt-2">
                                    Dit kan een aantal seconden duren
                                </p>
                            )}
                        </div>
                    )}
                    <div style={{whiteSpace: "pre-wrap"}}>
                        {reply}
                    </div>
                </div>
            </div>
        )
    }
}

export default App;
